import * as React from 'react';
import {
    CardLight,
} from 'one-ui-card/src/card-light';
import Table from "antd/lib/table";

import {
    PrescriptionModel
} from './model';

import {
    PrescriptionCardProps
} from './props';

import Skeleton from 'antd/lib/skeleton';

import {
    checkCardHasError,
    TabErrorMsg
} from 'one-card-notification';

/**
 * This function returns the Prescription Card
 * @param props is a component property
 * @returns JSX code for Prescription Tab Card
 */
export const PrescriptionCard = <M extends PrescriptionModel>(
    props: PrescriptionCardProps<M>
) => {
    const {
        model,
        title,
        skeleton
    } = props;

    const {
        prescriptiondata
    } = model || {};

    const {
        prescription_skeleton,
    } = skeleton;

    let tabledata: any = [];
    tabledata = prescriptiondata || [];
    
    const columns = [
        {
            title: "Medication",
            dataIndex: "medication",
            key: "medication"
        },
        {
            title: "Fills Remaining",
            dataIndex: "fillsremaining",
            key: "fillsremaining"
        }
    ];

    let result = (
        <Table size="small" columns={columns} dataSource={tabledata} pagination={{defaultPageSize: 2}}/>
    );

    // If Pending Referrals skeleton is true
    if (prescription_skeleton) {
        result = (<Skeleton active paragraph={{ rows: 1 }} />);
    }

    return (
        <CardLight
            title={title}
            body={
                result
            }
        />
    );
};